import React from 'react';
/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export const Goal7 = () => (
  <SVG
    width="50"
    height="50"
    viewBox="0 0 2250 2250"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path d="M2250,2250H0V0H2250Z" fill="#fbc61a" />
    <Path
      d="M1125.69,1095.84c186.66.78,332,151.11,332.57,331.5.57,183.53-147.38,333.23-330.86,333.81-184.52.59-329.44-146.38-334-323.86C788.61,1252.45,935.84,1096.73,1125.69,1095.84Zm-51.5,166c-70,20-133.42,96-118.82,192.27,12.87,84.83,93.81,150.23,180,144.31,91.94-6.32,161.35-78.84,163.38-170.68,1.62-73.71-61-159.32-121.5-165.41,0,18.52.16,37-.11,55.48-.07,5,1.46,7.81,6,10.6,40.21,25,59.38,61.48,55.45,108.51-5,59.56-56.6,104.68-118.54,102.48-55.66-2-104.54-49.17-107.16-106.68-2.07-45.33,17.2-80.06,55.42-104.43,2.41-1.54,5.65-4.35,5.7-6.63C1074.39,1301.93,1074.19,1282.19,1074.19,1261.83Zm27,22.3q0,26.61,0,53.21c0,15.51,10.78,27.16,24.88,27.07,13.72-.1,24.35-11.7,24.37-26.75q0-53.22,0-106.43c0-15.25-10.48-26.57-24.43-26.61-14.28,0-24.79,11.38-24.82,27Q1101.17,1257.9,1101.2,1284.13Z"
      fill="#fff"
    />
    <Path
      d="M181.71,193.12h197c.19,2.35.39,4.49.52,6.64,1.9,30.68-2.81,60.42-10.22,90.25-27,108.75-53,217.75-79.07,326.71-1.27,5.28-3.24,6.78-8.44,6.72-22.24-.27-44.49-.1-66.74-.13-1.91,0-3.83-.29-6.54-.5,30-122.29,59.92-244,90.1-367H181.71Z"
      fill="#fff"
    />
    <Path
      d="M1248.6,356.85V191c20.8,1.3,41.29,1.29,61.34,4.23,16.67,2.45,25,14,26.7,30.79a76.44,76.44,0,0,1,.53,10.46c-.56,14.31-4.58,26.63-20.34,31.9,25.93,13.62,33.81,49.58,16.78,72.79a36.61,36.61,0,0,1-28.77,15.45C1286.41,357.44,1267.91,356.85,1248.6,356.85Zm30.55-21.2c10.95-.3,23.17,3.2,29.57-8a36.83,36.83,0,0,0-.41-37.86c-6.41-10.83-18.23-8.76-29.16-9Zm.15-122.13v46c10.46-.34,21.65,2.49,27.8-8,5.41-9.19,6.15-20.15.71-29.46C1301.56,211.38,1289.8,214.93,1279.3,213.52Z"
      fill="#fff"
    />
    <Path
      d="M932.66,191.36c19.59.92,38.91.38,57.76,3.09,22.52,3.24,32.8,17.85,32.17,42.36-.37,14.92-2.1,29.66-17.16,38.43-1.26.73-1.43,4.84-.84,7,6.07,22.39,12.42,44.71,18.66,67.05.64,2.33,1.1,4.7,1.77,7.57H995c-3-11.2-6.1-22.65-9.13-34.12q-4-15.21-7.89-30.43c-2.7-10.58-2.68-10.58-14.94-9.65v74.05H932.66Zm30.46,71.27c10.64-.25,21.79,1.68,27.28-9.18,5.41-10.7,5.71-22.81-.94-33-6-9.14-16.56-7-26.34-7.09Z"
      fill="#fff"
    />
    <Path
      d="M913.56,275.17c0,15,1,30-.23,44.86-2.07,24.11-15.44,36.72-39.61,38.77a80.78,80.78,0,0,1-20.84-.83C834.5,354.66,822,342.19,821,321.56c-1.53-31.34-2-62.91.08-94.19C822.89,200,845,186.8,875.89,190.9c25.75,3.42,38.28,19.42,38.81,49.81.19,11.48,0,23,0,34.46Zm-30.14-1.06h0c0-14.73.46-29.47-.13-44.18-.56-13.84-10.82-20.42-23.2-15.74-8.32,3.14-9.5,10.47-9.56,17.81-.23,27.7-.16,55.41,0,83.12A49.33,49.33,0,0,0,852,326.17c1.41,6,5.52,9.16,11.56,10.13,11.63,1.87,19.17-3.84,19.69-16.51C883.91,304.59,883.42,289.34,883.42,274.11Z"
      fill="#fff"
    />
    <Path
      d="M1041.05,357.24v-165c21.42.49,42.66-2.31,63.42,3.29,16.18,4.35,25.12,16.41,25.65,32.31,1,30.91,1.77,62-.33,92.77-1.56,23.07-15.1,33.8-37.83,36.15-3.72.39-7.48.43-11.22.45C1067.78,357.27,1054.82,357.24,1041.05,357.24Zm30.43-143.13V335.57c22.89,1.78,29-3.68,29.21-26s.1-44.45,0-66.68a141.46,141.46,0,0,0-1.14-15.64c-.84-7.16-5.39-11.23-12.17-12.31C1082.28,214.13,1077,214.36,1071.48,214.11Z"
      fill="#fff"
    />
    <Path
      d="M1774.74,191.27c19.81,1,39.28,1.06,58.47,3.37,17.32,2.09,28.86,13.56,29.64,30.86,1.42,31.62,2,63.43.15,95-1.35,22.62-14,33-36.19,36.08a90.15,90.15,0,0,1-12,.65c-13.19.08-26.39,0-40.1,0Zm30.09,145.14c5.87-.54,10.84-.78,15.75-1.48,7.5-1.08,12.1-6.13,12.2-13.16.46-31.2.38-62.42.2-93.63,0-5.91-3.25-10.92-9.3-12.23s-12.48-1.38-18.85-2Z"
      fill="#fff"
    />
    <Path
      d="M1386.16,625.5h-29.9V461.29c21.35.74,42.8-2.64,63.83,3.38,14.09,4,23,13.43,24.45,28.05a128.79,128.79,0,0,1-.61,29.69c-1.35,10.1-7.27,17.93-17.7,22.61l22.6,80.73c-9.58,0-18.5.28-27.38-.25-1.62-.1-3.85-3.3-4.44-5.44-5.41-19.71-10.52-39.52-15.73-59.29-2.9-11-2.91-11-15.12-9.15Zm0-94.26c10.56-.15,21.61,2,27.41-8.52,5.93-10.81,6.1-23.11-.69-33.47-6.19-9.44-17-6.77-26.72-6.92Z"
      fill="#fff"
    />
    <Path
      d="M1192.89,625.48h-25.47V461.22c5.77,0,11.53-.52,17.1.27,2.15.3,4.64,3.23,5.67,5.54,10.89,24.65,21.51,49.42,32.22,74.15a17.32,17.32,0,0,0,4.89,7.09V461.76h25v164c-5.75,0-11.68.48-17.44-.28-1.81-.23-3.71-3.56-4.67-5.85-11.62-27.59-23.06-55.25-34.56-82.89-.57-1.37-1.19-2.71-2.75-6.24Z"
      fill="#fff"
    />
    <Path
      d="M933.2,461.24c5.78,0,11.54-.53,17.1.27,2.14.31,4.6,3.31,5.64,5.66,11,24.86,21.69,49.85,32.5,74.79a20.41,20.41,0,0,0,4.48,7v-87h25.17V625.76c-5.75,0-11.26.55-16.56-.27-2.11-.33-4.49-3.37-5.48-5.71-11.59-27.33-22.93-54.75-34.34-82.15a9,9,0,0,0-2.86-4v91.65H933.2Z"
      fill="#fff"
    />
    <Path
      d="M1728.48,192.57h24.66V357.25c-4.27,0-8.48-.38-12.6.09-5.1.58-7.49-1.48-9.39-6.13-11.28-27.72-22.87-55.32-34.36-82.95a8.62,8.62,0,0,0-3.21-4.26v92.77h-25.24V192.22c6,0,11.94-.44,17.74.26,1.87.23,4,3.21,4.94,5.39,11,24.89,21.69,49.86,32.51,74.8a16.58,16.58,0,0,0,5,7Z"
      fill="#fff"
    />
    <Path
      d="M1429.21,1903c-1.45,13.21-9.55,23.71-21.62,26.91a27.38,27.38,0,0,1-30.87-12.66q-35.33-61.24-70.45-122.61c-7.93-13.86-3.44-30.93,9.73-38.38,13.35-7.56,30.16-2.76,38.11,11q34.56,60,68.91,120.06C1425.77,1892.16,1427.18,1897.75,1429.21,1903Z"
      fill="#fff"
    />
    <Path
      d="M770.18,1601.31c13.29.83,24.53,8.75,27.65,20.12a28,28,0,0,1-13,32.17q-61.24,35.31-122.6,70.46a27.51,27.51,0,1,1-27.73-47.53q61.53-35.61,123.24-70.88C761.48,1603.51,766,1602.72,770.18,1601.31Z"
      fill="#fff"
    />
    <Path
      d="M1453.44,1632c.16-23.86,22.17-37.57,39.65-27.78,42.21,23.65,84.14,47.81,126,72,12.2,7.06,15.93,24.49,8.71,37-7,12.12-23.76,17.67-35.82,10.86q-63.49-35.87-126.58-72.47A23.73,23.73,0,0,1,1453.44,1632Z"
      fill="#fff"
    />
    <Path
      d="M646.28,1398.15q34.88,0,69.74,0c16.09,0,28.58,12.09,28.56,27.45s-12.38,27.76-28.39,27.79q-70.11.13-140.23,0c-16,0-28.47-12.28-28.52-27.63s12.38-27.57,28.36-27.6Q611,1398.09,646.28,1398.15Z"
      fill="#fff"
    />
    <Path
      d="M1098.2,1906c0-23.25,0-46.5,0-69.75,0-16.54,12.14-29.27,27.71-29.25s27.53,12.67,27.54,29.34q0,69.38,0,138.74c0,16.71-11.91,29.21-27.63,29.18-15.54,0-27.6-12.76-27.62-29.26Q1098.15,1940.5,1098.2,1906Z"
      fill="#fff"
    />
    <Path
      d="M1427.65,948.86c-1.44,4.17-2.27,8.68-4.41,12.44q-35.07,61.85-70.53,123.46c-7.58,13.16-25,17.43-37.85,9.77-12.53-7.44-17.24-24.42-9.92-37.28q35-61.44,70.22-122.71c6.82-11.89,19.39-17,32.59-13.37C1419.17,924.29,1426.85,935.34,1427.65,948.86Z"
      fill="#fff"
    />
    <Path
      d="M798.25,1222.8c0,20.49-22,34.15-39.88,24.11q-62.94-35.37-125.37-71.66c-12.34-7.13-16.29-24.35-9.26-36.89s24-18,36.37-11q63.15,35.7,125.94,72C794.88,1204.53,798.16,1212.94,798.25,1222.8Z"
      fill="#fff"
    />
    <Path
      d="M855.2,920.8c6.31.07,14.72,4.31,20.23,13.91q35,61,70.05,122c7.92,13.84,3.53,31-9.63,38.42-13.39,7.6-30.11,2.91-38.1-10.92Q862.4,1023,827.26,961.62C816.86,943.38,829.9,921,855.2,920.8Z"
      fill="#fff"
    />
    <Path
      d="M851.55,1931.13c-20-.14-33.7-22-23.89-39.53,23.64-42.21,47.79-84.15,72-126,7.12-12.28,24.61-16,37-8.82,12.07,7,17.65,23.8,10.84,35.88q-35.84,63.51-72.44,126.59C870,1928,861.44,1931.22,851.55,1931.13Z"
      fill="#fff"
    />
    <Path
      d="M1453.17,1221.65c.19-10.51,4.39-18.61,13.77-24,40.89-23.43,81.69-47,122.59-70.45,13.25-7.59,30.44-2.89,37.82,10a27.77,27.77,0,0,1-10.26,37.72q-61.53,35.54-123.22,70.84C1475.21,1256.41,1453.08,1243.09,1453.17,1221.65Z"
      fill="#fff"
    />
    <Path
      d="M1153.47,946.19q0,34.5,0,69c0,16.8-11.82,29.16-27.63,29.11s-27.61-12.48-27.62-29.23q-.06-69.36,0-138.73c0-16.73,11.85-29,27.72-29s27.5,12.23,27.53,29.13Q1153.52,911.31,1153.47,946.19Z"
      fill="#fff"
    />
    <Path
      d="M1605.72,1398.15q35.23,0,70.48,0c15.71,0,27.82,11.79,28,27.08a27.56,27.56,0,0,1-27.89,28.14q-70.49.18-141,0a27.88,27.88,0,0,1-28.12-28c.18-15.5,12.48-27.17,28.74-27.2Q1570.86,1398.12,1605.72,1398.15Z"
      fill="#fff"
    />
    <Path
      d="M1554.22,515.66h-28.43c-.53-7.51-.59-14.72-1.67-21.78-1.24-8.2-6.17-11.88-14.55-12.09-8.23-.21-13.51,3.4-15.65,11a33.71,33.71,0,0,0-1.36,8.84q-.16,40.86,0,81.72a42.48,42.48,0,0,0,1.4,9.6c2,8.47,6.17,11.86,14.61,12.33s14.74-2.76,16.48-11c2.14-10.12,2.45-20.63,3.65-32l-18-.94v-18.6h44.06v82.92c-5.55,0-10.76.3-15.9-.19-1.5-.14-3.43-2.28-4-3.93-.91-2.44-.83-5.25-1.45-10.07-9.54,15.88-22.65,18.54-37.71,15.92-18.8-3.27-30.73-14-32.24-36.73a648,648,0,0,1,.24-94.91c2.22-27.37,20-38.69,51.13-36.28,26.83,2.06,38.4,15.68,39.39,44.05C1554.33,507.38,1554.22,511.12,1554.22,515.66Z"
      fill="#fff"
    />
    <Path
      d="M621.09,564.22h29.45c.9,16.7,1.93,33.45-7.78,48.28-9,13.78-23.64,16.07-38.44,15.64-26.5-.78-41.44-12.69-43.39-39a665.94,665.94,0,0,1-.24-89.79c1.8-29.31,19.34-42.15,52.07-39.73,23.88,1.77,35.2,13.51,37.75,37.61.8,7.64.12,15.43.12,23.64H621.24c0-7.82.36-15.71-.08-23.54-.61-10.79-5.07-15.32-14.23-15.52-9.45-.19-15.77,4.82-15.92,15q-.69,46.44,0,92.9c.18,10.17,4.87,14.52,13,15.5,9.77,1.17,16.17-3.5,16.87-13.42C621.58,582.87,621.09,573.88,621.09,564.22Z"
      fill="#fff"
    />
    <Path
      d="M651.88,357.24c-8.84,0-16.56.36-24.21-.27-1.85-.15-4.47-3.34-4.95-5.53-2-9-3-18.22-5.07-27.21-.45-2-3.61-3.34-5.55-5-.15-.12-.48,0-.73,0-22.74-.72-22.72-.72-26.34,21.52-.88,5.37-1.95,10.7-2.93,16H553.5c11.18-55,22.26-109.48,33.47-164.61,9.52,0,18.74-.31,27.9.28,1.71.11,4.17,3.59,4.64,5.86Q633.94,268,648,337.68C649.19,343.78,650.4,349.88,651.88,357.24ZM603.72,238.3l-1.72,0c-3.25,20.08-6.5,40.15-9.79,60.42h21.42C610.25,278.14,607,258.22,603.72,238.3Z"
      fill="#fff"
    />
    <Path
      d="M1557.83,356.71c3.88-19.49,7.56-38.34,11.38-57.15,6.87-33.76,13.91-67.48,20.64-101.27.89-4.48,2.28-6.46,7.18-6.21,8.21.41,16.46.11,25.65.11,11.13,54.84,22.21,109.49,33.4,164.65h-28.19l-6.79-37.24h-27.95c-2.23,12.21-4.46,24.4-6.78,37.11Zm49.89-120-1.23-.07c-3.34,20.63-6.69,41.27-10.1,62.24h21.36Z"
      fill="#fff"
    />
    <Path
      d="M887.45,461.2c11.13,54.93,22.15,109.3,33.27,164.2H892.54c-2.2-12.13-4.41-24.3-6.69-36.9H857.78c-1.93,10.76-3.71,21.56-5.94,32.27-.38,1.86-2.56,4.68-4,4.77-8.15.47-16.33.22-25.39.22l11.47-56.45c6.91-34,14-67.89,20.6-101.91,1-5.13,3.07-6.47,7.88-6.29C870.55,461.43,878.77,461.2,887.45,461.2Zm-14.93,44.87-1.38-.09c-3.35,20.47-6.71,40.93-10.14,61.92h21.51Z"
      fill="#fff"
    />
    <Path
      d="M1236.34,357.23c-8.59,0-16.54.25-24.45-.22-1.54-.09-3.84-2.73-4.23-4.54-1.87-8.78-3.53-17.63-4.63-26.54-.66-5.37-2.83-7.16-8.19-6.79-6.9.47-13.87.11-21.13.11-2.35,12.92-4.57,25.13-6.85,37.63h-28.64c11.16-54.93,22.22-109.36,33.46-164.66,9.55,0,19-.27,28.33.25,1.56.09,3.81,3.4,4.25,5.54,7.19,34.44,14.14,68.93,21.12,103.42q4.9,24.19,9.76,48.42C1235.57,352,1235.85,354.17,1236.34,357.23Zm-37.95-58.29c-3.51-21.32-6.89-41.87-10.26-62.41l-1.19.14c-3.31,20.58-6.62,41.16-10,62.27Z"
      fill="#fff"
    />
    <Path
      d="M748.89,461.66h68.2v21.07H779.18v46.32h30v22.32h-30v53.2h38.62v20.91H748.89Z"
      fill="#fff"
    />
    <Path
      d="M1153.21,461.74v20.89h-38.34v46.49h29.87v22.06H1115v53.39h38.1V625.3h-68.3V461.74Z"
      fill="#fff"
    />
    <Path
      d="M1341.7,482.69H1304v46.65h29.83v21.82h-30v53.36h38.31v20.63h-68.55V461.62h68.07Z"
      fill="#fff"
    />
    <Path
      d="M1438.73,192.59h68.18v21.52h-38.05v46.5h29.92V282h-29.73v54h38v20.72h-68.33Z"
      fill="#fff"
    />
    <Path
      d="M1657.79,461.19c-10.71,32.82-21,64.07-31,95.4a48.65,48.65,0,0,0-2.17,13.88c-.24,18.17-.1,36.34-.1,54.91h-29.32c0-6-.41-11.87.06-17.71,2.44-30.14-2.51-58.93-13.77-87-6.49-16.16-11.17-33-16.62-49.63-.92-2.8-1.63-5.66-2.8-9.76,9.11,0,17.47-.26,25.79.25,1.45.09,3.3,3.25,4,5.31,6.11,19,12,38,18.52,58.85,4.48-14.86,8.48-28,12.43-41.26,1.79-6,3.69-11.92,5.16-18,1-4.14,3.16-5.54,7.38-5.36C1642.59,461.43,1649.91,461.19,1657.79,461.19Z"
      fill="#fff"
    />
    <Path d="M723.75,282.1H694.54v74.8H664.15V192.6h67.11v21H694.81v47.09h28.94Z" fill="#fff" />
    <Path d="M810.27,192.66v21H773.89v47h28.72v21.29H773.77v74.92H743.22V192.66Z" fill="#fff" />
    <Path d="M1357.47,356.81v-164h29.67V335.86h39v20.95Z" fill="#fff" />
    <Path d="M697.11,604.78h39v20.59H667.81V461.63h29.3Z" fill="#fff" />
  </SVG>
);
